<template>
  <div class="content">
<!--    <img alt="Vue logo" src="../assets/logo.png">-->
<!--    <help-field title="How can we help"/>-->
    <order-number-input-field title="HELP CENTER"/>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderNumberInputField from "../components/order-number-input-filed/Order-Number-Input-Field";
// import HelpField from "../components/help-field/Help-Field";

export default {
  name: 'Home',
  components: {
    // HelpField,
    OrderNumberInputField, 
  }
}
</script>
